<template>
  <div class="homepage-component hp-quick-links--with-content" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="secondary-background-white padding-lg">
      <div class="container">
        <div class="row flex-row align-items-center">
          <div class="col-xs-12 col-md-5 animation-element slide-left mobile-center">
            <div v-if="brand === 'kia'"><h2>Are you ready to flip the switch?</h2><p>Engineered with purpose. Designed to inspire. Kia is pioneering the future of mobility. Kia currently offers all-electric vehicle options ranging between 232 and 310 miles of EPA-estimated range.</p><p>Hometown Kia is committed to finding the right EV for you. Learn more about Kia's EV lineup to see which model is right for you or shop now to get started today!</p></div>
            <div v-else-if="brand === 'ford'"><h2>Order Exactly What You Want</h2><p>The Ford BPN Dealer experience guides you in buying the right vehicle to fit your needs. Personnel are trained and certified in commercial trucks and their applications. They also use a proprietary diagnostic software called Commercial Vehicle Tools (CVT) to recommend the most appropriate vehicle specifications for your business based on your unique requirements (payload, cargo space, upfit needs, etc.)</p></div>
            <div v-else-if="brand === 'nissan'"><h2>What our customers are saying</h2><p>We feel good about the service that we provide but we don't know how you feel until we ask. Let us know what you thought about your interaction with our dealership.</p><p>Hometown Nissan is committed to excellence, but we are also always looking for ways to improve. Let us know how well we hit our mark of perfection by rating us below. We appreciate you taking the time!</p></div>
            <div v-else-if="brand === 'cjdr'"><h2>LIVE A GRAND DREAM</h2><p>Built for those who want to share a lifetime of success with the people they hold dear. The All-New Grand Wagoneer and Wagoneer reinterpret their own legacies and take the premium SUV into uncharted territories of style, comfort and adventure. These are more than sport utility vehicles They're the means to make exceptional memories and create your own legend.</p></div>
            <div v-else-if="brand === 'mitsubishi'"><h2>WHO MAKES MITSUBISHI CARS?</h2><p>At Mitsubishi Motors, we see the automotive industry differently. We've challenged convention for more than 100 years with innovative approaches in the way we engineer and build our vehicles. Guided by an adventurous and ambitious spirit and a challenger upstart attitude, our dreamers, designers and engineers are redefining choices in mobility for a whole new generation of independent, modern and savvy consumers.</p></div>
            <div v-else><h2>Lorem Ipsum Id Volutpat Lacus</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque mauris pellentesque pulvinar pellentesque habitant morbi tristique senectus et. Diam donec adipiscing tristique risus nec feugiat. Imperdiet sed euismod nisi porta lorem mollis aliquam. Mi in nulla posuere sollicitudin aliquam ultrices sagittis orci a. Mattis enim ut tellus elementum sagittis vitae.</p></div>
            <div class="btn-row--lineup">
              <a href="#" class="primary-btn" :class="brandButtonClass">{{ contentBtn }}</a>
              <a v-if="brand === 'kia'" href="#" class="secondary-btn" :class="brandButtonClass">Shop Now</a>
            </div>
          </div>
          <div class="col-xs-12 col-md-7 animation-element appear-grow-slow reveal2">
            <img :src="contentImg" class="img-responsive center-block img--one">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand,
      }
    },
    computed: {
      brandName () {
        if (this.brand === 'none') {
          return 'Dealer';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      },
      contentImg () {
        if (this.brand === 'kia') {
          return require('../../static/images/kia-ev-stock-img.png');
        } else if (this.brand === 'ford' || this.brand === 'nissan') {
          return require('../../static/images/computer-man-stock-img.jpeg');
        } else if (this.brand === 'chevrolet') {
          return this.images.lifestyleImages.truckImage;
        } else if (this.brand === 'cjdr') {
          return this.images.lifestyleImages.defaultImage;
        } else {
          return this.images.lifestyleImages.suvImage;
        }
      },
      contentBtn () {
        if (this.brand === 'kia') {
          return "Learn More"
        } else if (this.brand === 'ford') {
          return "Work Trucks"
        } else if (this.brand === 'nissan') {
          return "Leave a Review"
        } else {
          return "Shop Now"
        }
      },
      brandButtonClass() {
        if (this.brand.toLowerCase() !== 'none') {
          return this.brand.toLowerCase() + '-btn';
        } else {
          return 'default-btn';
        }
      }
    },
    mounted() {
      $(function() {
        var scrollSwoop = {
          init: function() {
            var $animation_elements = $('.animation-element');
            var $window = $(window);
          
            function check_if_in_view() {
              var window_height = $window.height() * .85;
              var window_top_position = $window.scrollTop();
              var window_bottom_position = (window_top_position + window_height);
              $.each($animation_elements, function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);
          
                if ((element_bottom_position >= window_top_position) &&
                    (element_top_position <= window_bottom_position)) {
                  if ($element.hasClass("reveal2") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 300);
                  }
                  else if ($element.hasClass("reveal3") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 600);
                  } 
                  else if ($element.hasClass("reveal4") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 900);
                  }
                  else {
                    $element.addClass('in-view');
                  }
                }
              });
            }
            $window.on('scroll resize', check_if_in_view);
            $window.trigger('scroll');
          }
        }
        $(document).ready(scrollSwoop.init);
      });
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.hp-quick-links--with-content p {
  font-size: 18px;
}
.hp-quick-links--with-content h2 {
  margin-bottom: 20px;
}
.hp-quick-links--with-content .btn-row--lineup {
  display: flex;
  justify-content: flex-start;
}
.hp-quick-links--with-content[data-brand="kia"] .btn-row--lineup {
  display: flex;
  justify-content: space-evenly;
}
.hp-quick-links--with-content .flex-row {
  display: flex;
  flex-wrap: wrap;
}
.hp-quick-links--with-content .align-items-center {
  align-items: center;
}
.btn-row--lineup a {
  margin: 15px 0px;
}
@media (max-width: 991px) {
  .mobile-center {
    text-align: center;
  }
  .hp-quick-links--with-content p {
    font-size: 16px;
  }
}
@media (max-width: 500px) {
  .btn-row--lineup {
    flex-direction: column;
  }
  .btn-row--lineup a {
    margin: 15px auto;
    width: 75%
  }
  .hp-quick-links--with-content p {
    font-size: 15px;
  }
}

.animation-element.appear-grow-slow {
  opacity: 0;
  -moz-transition: all 1500ms ease-out;
  -webkit-transition: all 1500ms ease-out;
  -o-transition: all 1500ms ease-out;
  transition: all 1500ms ease-out;
  transition-property: opacity, transform;
  -moz-transform: scale(.97);
  -webkit-transform: scale(.97);
  -o-transform: scale(.97);
  -ms-transform: scale(.97);
  transform: scale(.97);
}
.animation-element.appear-grow-slow.in-view {
  opacity: 1;
  -moz-transform: scale(1);
  -webkit-transform: scale(1);
  -o-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}
.animation-element.slide-left {
  opacity: 0;
  -moz-transition: all 700ms linear;
  -webkit-transition: all 700ms linear;
  -o-transition: all 700ms linear;
  transition: all 700ms linear;
  transition-property: opacity, transform;
  -moz-transform: translate3d(-50px, 0px, 0px);
  -webkit-transform: translate3d(-50px, 0px, 0px);
  -o-transform: translate(-50px, 0px);
  -ms-transform: translate(-50px, 0px);
  transform: translate3d(-50px, 0px, 0px);
}
.animation-element.slide-left.in-view {
  opacity: 1;
  -moz-transform: translate3d(0px, 0px, 0px);
  -webkit-transform: translate3d(0px, 0px, 0px);
  -o-transform: translate(0px, 0px);
  -ms-transform: translate(0px, 0px);
  transform: translate3d(0px, 0px, 0px);
}

.hp-quick-links--with-content[data-brand="kia"] .btn-row--lineup a {
  padding: 17px 34px !important;
}
.hp-quick-links--with-content[data-brand="mitsubishi"] .btn-row--lineup a {
  padding: 1rem 1.5rem !important;
}
</style>
